export const langWindInfos = {
  fr: {
    title: 'VENT',
    min: `min`,
    moy: `moy`,
    max: `max`,
    maxSpeedTitle: `Vitesse max (knts)`,
    avgSpeedTitle: `Vitesse moy (knts)`,
    dirTitle: `Direction (°)`,
    maxAvg: 'VENT vitesse max (moyenne session)',
    avgAvg: 'VENT vitesse moyenne (moyenne session)',
  },
  eng: {
    title: 'WIND',
    min: `min`,
    moy: `avg`,
    max: `max`,
    maxSpeedTitle: `Max speed (knts)`,
    avgSpeedTitle: `Avg speed (knts)`,
    dirTitle: `Direction (°)`,
    maxAvg: 'VENT vitesse max (moyenne session)',
    avgAvg: 'VENT vitesse moyenne (moyenne session)',
  },
}
